import React from 'react';
import {
  IconFilter,
  FilterInputComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';

const TargetFilter = () => (
  <IconFilter
    hasApplyButton
    hasClearButton
    name="target"
    position="bottom right"
    placement="bottom-end"
    as={FilterInputComponent}
  />
);

export default TargetFilter;
